module.exports = __webpack_public_path__ + "img/Layer 8.308d0652.svg";